/* Neues Mega-Menü und Handy-Menü, aus dem Prototyp übernommen */
(function () {
  'use strict';
  const $ = (s, r) => (r || document).querySelector(s), $$ = (s, r) => Array.from((r || document).querySelectorAll(s));

  /* Partikel über den Pixel-Figuren im Menü, wie auf der Startseite (sm-home.js): <span class="pxfx" data-fx="typ:x:y:rate;…">.
     Startet erst, wenn ein Panel aufgeht, und hält an, sobald keine Figur mehr sichtbar ist; nie bei „Bewegung reduzieren“. */
  const FX = (() => {
    const RM = matchMedia('(prefers-reduced-motion: reduce)').matches;
    const COL = { sparks: ['#fff3b0', '#ffd34d', '#ff9a2e', '#ff6b1f'], steam: ['rgba(255,255,255,.95)', 'rgba(214,222,240,.9)'], confetti: ['#ff6b1f', '#6f9bff', '#f5ae2e', '#1c7f47', '#e84d8a', '#ffffff'], twinkle: ['#ffffff', '#fff8c4', '#ffe066'], dust: ['#d9d3c7', '#bfb8ab', '#ffffff'] };
    const items = new Set(); let run = false, last = 0;
    const parse = s => s.split(';').filter(Boolean).map(p => { const [type, x, y, rate] = p.split(':'); return { type, x: +x, y: +y, rate: +(rate || 4), acc: Math.random() }; });
    function attach(el) {
      if (RM || el._pxfx || !el.dataset.fx) return;
      const cv = document.createElement('canvas'); cv.className = 'pxfx-cv'; cv.setAttribute('aria-hidden', 'true'); el.appendChild(cv);
      el._pxfx = { el, cv, ctx: cv.getContext('2d'), em: parse(el.dataset.fx), parts: [], w: 0, h: 0, ps: 3 }; items.add(el._pxfx);
    }
    function size(it) { const w = it.el.offsetWidth, h = it.el.offsetHeight; if (w !== it.w || h !== it.h) { it.w = it.cv.width = w; it.h = it.cv.height = h; it.ps = Math.max(2, Math.round(Math.min(w, 420) / 70)); } }
    function spawn(it, type, x, y) {
      const s = it.ps, c = COL[type] || COL.sparks, R = Math.random, p = { type, x, y, col: c[Math.floor(R() * c.length)], t: 0, sz: s * (R() < .3 ? 2 : 1), ph: R() * 6 };
      if (type === 'steam') Object.assign(p, { vx: 0, vy: -.35 * s, g: 0, life: 50 + R() * 40, sz: s * (R() < .5 ? 1 : 2) });
      else if (type === 'confetti') Object.assign(p, { vx: (R() * 3 - 1.5) * s, vy: -(R() * 3 + 2) * s, g: .14 * s, life: 60 + R() * 40 });
      else if (type === 'twinkle') Object.assign(p, { x: x + (R() - .5) * it.w * .16, y: y + (R() - .5) * it.h * .1, vx: 0, vy: 0, g: 0, life: 26 });
      else if (type === 'dust') Object.assign(p, { vx: (R() * 1.6 - .2) * s * .5, vy: (R() * 1.2 - .8) * s * .5, g: .02 * s, life: 16 + R() * 14 });
      else Object.assign(p, { vx: (R() * 2.4 - 1.2) * s * .6, vy: -(R() * 1.8 + .4) * s * .6, g: .09 * s, life: 18 + R() * 20 });
      it.parts.push(p);
    }
    function step(it, dt) {
      size(it); const { ctx, ps } = it; ctx.clearRect(0, 0, it.w, it.h);
      it.em.forEach(e => { e.acc += e.rate * dt; while (e.acc >= 1) { e.acc -= 1; spawn(it, e.type, e.x * it.w, e.y * it.h); } });
      it.parts = it.parts.filter(p => {
        p.t++; p.vy += p.g; p.x += p.vx + (p.type === 'steam' ? Math.sin(p.t / 14 + p.ph) * ps * .25 : 0); p.y += p.vy;
        if (p.t > p.life || p.y > it.h + 10 || p.y < -10 || p.x < -10 || p.x > it.w + 10) return false;
        const a = Math.max(0, 1 - p.t / p.life); ctx.globalAlpha = p.type === 'steam' ? a * .8 : a; ctx.fillStyle = p.col;
        const X = Math.round(p.x / ps) * ps, Y = Math.round(p.y / ps) * ps;
        if (p.type === 'twinkle') { const k = p.t < 13 ? p.t / 13 : (26 - p.t) / 13, L = Math.round(k * 2) * ps; ctx.fillRect(X, Y, ps, ps); if (L) { ctx.fillRect(X - L, Y, L, ps); ctx.fillRect(X + ps, Y, L, ps); ctx.fillRect(X, Y - L, ps, L); ctx.fillRect(X, Y + ps, ps, L); } }
        else ctx.fillRect(X, Y, p.sz, p.sz);
        return true;
      });
      ctx.globalAlpha = 1;
    }
    function frame(n) {
      const dt = Math.min(.05, (n - (last || n)) / 1000); last = n; let any = false;
      items.forEach(it => { if (!it.el.isConnected) { items.delete(it); return; } if (it.el.offsetParent !== null) { step(it, dt); any = true; } });
      if (any && !document.hidden) requestAnimationFrame(frame); else { run = false; last = 0; }
    }
    return { on(root) { if (RM || !root) return; $$('[data-fx]', root).forEach(attach); if (!run && items.size) { run = true; requestAnimationFrame(frame); } } };
  })();

  const mg = $('#smmMg');
  if (mg && !mg.dataset.on) {
    mg.dataset.on = '1';
    const hdr = mg.closest('header') || document.querySelector('header'), box = $('.mg-box', mg), inner = $('.mg-in', mg), ink = $('.smm-ink');
    const btns = $$('.smm-nb[data-p]');
    const FINE = matchMedia('(hover: hover) and (pointer: fine)').matches;
    let cur = null, tOpen = 0, tClose = 0, tClean = 0, openY = 0;
    const fit = () => { box.style.height = cur ? inner.offsetHeight + 'px' : '0px'; };
    const moveInk = b => { if (!ink) return; if (!b) { ink.style.opacity = '0'; return; } const n = ink.parentElement.getBoundingClientRect(), r = b.getBoundingClientRect(); ink.style.left = (r.left - n.left) + 'px'; ink.style.width = r.width + 'px'; ink.style.opacity = '1'; };
    const open = id => {
      clearTimeout(tClose); clearTimeout(tClean);
      if (cur === id) return;
      $$('.mg-p', mg).forEach(p => p.classList.toggle('on', p.id === id));
      btns.forEach(b => b.setAttribute('aria-expanded', String(b.dataset.p === id)));
      // Direkt unter der Menüzeile ansetzen: der Belohnungs-Zeitstrahl liegt im Header darunter und würde sonst zwischen Menü und Panel durchscheinen
      const nv = $('.smm-nav'); if (nv && hdr) mg.style.top = Math.round(nv.getBoundingClientRect().bottom - hdr.getBoundingClientRect().top + 3) + 'px';
      cur = id; openY = scrollY; mg.classList.add('on'); mg.setAttribute('aria-hidden', 'false');
      moveInk(btns.find(b => b.dataset.p === id)); fit(); FX.on(document.getElementById(id));
    };
    const close = () => {
      clearTimeout(tOpen); if (!cur) return;
      cur = null; mg.classList.remove('on'); mg.setAttribute('aria-hidden', 'true');
      btns.forEach(b => b.setAttribute('aria-expanded', 'false')); moveInk(null); fit();
      tClean = setTimeout(() => { if (!cur) $$('.mg-p.on', mg).forEach(p => p.classList.remove('on')); }, 450);
    };
    btns.forEach(b => {
      b.addEventListener('click', e => { e.stopPropagation(); if (FINE) open(b.dataset.p); else if (cur === b.dataset.p) close(); else open(b.dataset.p); });
      b.addEventListener('keydown', e => { if (e.key === 'ArrowDown') { e.preventDefault(); open(b.dataset.p); const a = $('#' + b.dataset.p + ' a'); if (a) setTimeout(() => a.focus(), 30); } });
      if (FINE) {
        b.addEventListener('mouseenter', () => { clearTimeout(tOpen); clearTimeout(tClose); tOpen = setTimeout(() => open(b.dataset.p), cur ? 60 : 140); });
        b.addEventListener('mouseleave', () => clearTimeout(tOpen));
      }
    });
    if (FINE && hdr) {
      hdr.addEventListener('mouseleave', () => { clearTimeout(tOpen); tClose = setTimeout(close, 260); });
      hdr.addEventListener('mouseenter', () => clearTimeout(tClose));
    }
    document.addEventListener('click', e => { if (!cur) return; if (e.target.closest('#smmMg a') || (!e.target.closest('#smmMg') && !e.target.closest('.smm-nb'))) close(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && cur) { const b = btns.find(x => x.dataset.p === cur); close(); if (b) b.focus(); } });
    mg.addEventListener('focusout', e => { if (cur && hdr && !hdr.contains(e.relatedTarget)) close(); });
    addEventListener('scroll', () => { if (cur && Math.abs(scrollY - openY) > 80) close(); }, { passive: true });
    addEventListener('resize', () => { if (cur) { fit(); moveInk(btns.find(b => b.dataset.p === cur)); } });

    // Vorschau-Spalte: großes Bild zum Menüpunkt unter der Maus
    $$('.mg-prev', mg).forEach(pv => {
      const panel = pv.closest('.mg-p'), im = $('img.big', pv), t = $('.cap b', pv), s = $('.cap span', pv), l = $('.cap a', pv);
      const def = { src: im.getAttribute('src'), k: 'px', t: t.textContent, s: s.textContent, h: l.getAttribute('href'), lt: l.textContent };
      let tt = 0, tw = 0;
      const show = (src, k, title, sub, href, lt) => {
        if (im.getAttribute('src') !== src) { im.classList.add('sw'); clearTimeout(tw); tw = setTimeout(() => { im.src = src; im.className = 'big' + (k && k !== 'foto' ? ' ' + k : ''); requestAnimationFrame(() => im.classList.remove('sw')); }, 110); }
        t.textContent = title; s.textContent = sub; s.hidden = !sub; l.setAttribute('href', href); l.textContent = lt;
      };
      $$('a[data-pi]', panel).forEach(a => {
        const go = () => { if (!a.dataset.pi) return; clearTimeout(tt); show(a.dataset.pi, a.dataset.pk, a.dataset.pt, '', a.getAttribute('href'), (pv.dataset.sub || 'Ansehen') + ' →'); };
        a.addEventListener('mouseenter', go); a.addEventListener('focus', go);
      });
      panel.addEventListener('mouseleave', () => { tt = setTimeout(() => show(def.src, def.k, def.t, def.s, def.h, def.lt), 260); });
    });
  }

  // Handy-Menü
  const mob = $('#smmMob'), burger = $('.smm-burger');
  if (mob && burger && !mob.dataset.on) {
    mob.dataset.on = '1';
    document.body.appendChild(mob);
    const lock = on => document.body.classList.toggle('overflow-hidden-tablet', on);
    const openM = () => { mob.hidden = false; burger.setAttribute('aria-expanded', 'true'); lock(true); setTimeout(() => { const x = $('.mob-x', mob); if (x) x.focus(); }, 40); };
    const closeM = () => { mob.hidden = true; burger.setAttribute('aria-expanded', 'false'); lock(false); burger.focus(); };
    burger.addEventListener('click', openM);
    mob.addEventListener('click', e => {
      if (e.target.closest('.mob-x')) return closeM();
      const h = e.target.closest('.acc-h[aria-controls]');
      if (h) { const b = document.getElementById(h.getAttribute('aria-controls')), on = h.getAttribute('aria-expanded') !== 'true'; h.setAttribute('aria-expanded', String(on)); if (b) b.hidden = !on; return; }
      if (e.target.closest('a')) { mob.hidden = true; burger.setAttribute('aria-expanded', 'false'); lock(false); }
    });
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !mob.hidden) closeM(); });
    addEventListener('resize', () => { if (!mob.hidden && innerWidth >= 990) closeM(); });
  }
})();
